import { mapGetters, mapActions } from 'vuex'
import { get, set } from 'lodash'
export default {
  data () {
    let validatorCarrier = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Vui lòng chọn hãng vận chuyển'))
      } else {
        callback()
      }
    }
    let validatorService = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Vui lòng chọn dịch vụ'))
      } else {
        callback()
      }
    }
    let validatorCityFrom = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Vui lòng chọn thành phố đi'))
      } else {
        callback()
      }
    }
    let validatorRegionTo = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Vui lòng chọn vùng miền đến'))
      } else {
        callback()
      }
    }
    return {
      localPriceTable: {
        carrier_id: undefined,
        service_id: undefined,
        service_mapping_id: undefined,
        city_from_id: undefined,
        region_to_id: undefined,
        amount: 0,
        cod_min_fee: 0,
        cod_fee: 0,
        cod_apply: 0,
        weight_first: 0,
        maximum_weight: 0,
        weight_step: 0,
        weight_step_fee: 0,
        lsf_type: 1,
        location_step_fee: 0,
        expected_unit: 0,
        return_fee: 0,
        expected_delivery: '',
        hour_apply: undefined,
        name: '',
        service_description: '',
        return_unit: 0
      },
      rules: {
        'name': [
          { required: true, message: 'Tên không thể để trống', trigger: 'change' },
          { min: 5, max: 255, message: 'Tên phải chứa từ 5 đến 255 ký tự', trigger: 'change' }
        ],
        'carrier_id': [
          {validator: validatorCarrier, trigger: 'change'}
        ],
        'service_id': [
          {validator: validatorService, trigger: 'change'}
        ],
        'city_from_id': [
          {validator: validatorCityFrom, trigger: 'change'}
        ],
        'region_to_id': [
          {validator: validatorRegionTo, trigger: 'change'}
        ],
        'amount': [
          {required: true, message: 'Giá không thể để trống', trigger: 'change'}
        ],
        'expected_delivery': [
          {required: true, message: 'Thời gian dự kiến giao hàng không thể để trống', trigger: 'change'}
        ],
        'service_mapping_id': [
          {required: true, message: 'Vui lòng chọn mapping id', trigger: 'change'}
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('carrier', ['carriers']),
    ...mapGetters('service', ['services']),
    ...mapGetters('city', ['cities']),
    ...mapGetters('region', ['regions']),
    ...mapGetters('priceTable', ['priceTableHelpers'])
  },
  methods: {
    ...mapActions('carrier', ['getAllCarriers']),
    ...mapActions('service', ['getAllServices']),
    ...mapActions('city', ['getAllCity']),
    ...mapActions('region', ['getAllRegion']),
    ...mapActions('priceTable', ['getAllPriceTableHelpers']),
    removeZero (key) {
      if (parseInt(get(this.localPriceTable, key)) === 0) {
        set(this.localPriceTable, key, '')
      }
    },
    addZero (key) {
      if (get(this.localPriceTable, key) === '') {
        set(this.localPriceTable, key, 0)
      }
    },
    newPriceTable () {
      this.localPriceTable = {
        carrier_id: undefined,
        service_id: undefined,
        service_mapping_id: undefined,
        city_from_id: undefined,
        region_to_id: undefined,
        amount: 0,
        cod_min_fee: 0,
        cod_fee: 0,
        cod_apply: 0,
        weight_first: 0,
        maximum_weight: 0,
        weight_step: 0,
        weight_step_fee: 0,
        lsf_type: 1,
        location_step_fee: 0,
        expected_unit: 0,
        expected_delivery: '',
        hour_apply: undefined,
        name: '',
        service_description: '',
        return_fee: 0,
        return_unit: 0,
        apply_only_customer: ''
      }
    }
  },
  mounted () {
    this.newPriceTable()
    if (!this.carriers.length) {
      this.getAllCarriers({limit: -1})
    }
    if (!this.services.length) {
      this.getAllServices({limit: -1, children: 1})
    }
    if (!this.cities.length) {
      this.getAllCity({limit: -1, sort: 'name:1'})
    }
    if (!this.regions.length) {
      this.getAllRegion({params: {limit: -1}})
    }
    if (!Object.keys(this.priceTableHelpers).length) {
      this.getAllPriceTableHelpers()
    }
  },
  watch: {
    localPriceTable: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pricetable/mixins/index.js